import {useEffect} from 'react'
import {CertificateViewModalHeader} from './CertificateViewModalHeader'
import {CertificateViewModalFormWrapper} from './CertificateViewModalFormWrapper'

const CertificateViewModal = () => {
    useEffect(() => {
        document.body.classList.add('modal-open')
        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [])

    return (
    <>
    <div
        className='modal fade show d-block'
        id='kt_modal_add_certificate'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
    >    
        <div className='modal-dialog modal-dialog-centered mw-700px'>
            <div className='modal-content'>
                <CertificateViewModalHeader />            
                <div className='modal-body scroll-y mx-10'>
                    <CertificateViewModalFormWrapper />
                </div>    
            </div>
        </div>    
    </div>
    <div className='modal-backdrop fade show'></div>
    
</>
)
}

export {CertificateViewModal}
